import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";
import { formatDate } from "../../../utils/commonFunctions";

function DateField({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "date",
    properties: {
      label: "Date Element",
      placeholder: "Enter Input Element here...",
      required: true,
    },
  });

  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setElement((prev) => ({ ...prev, ...data }));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }
    //check prefilled field -Lovejot(07-DEC-2022)
    if (
      data?.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, isChild]);

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );
  return (
    <div className="form-group col-md-12 form-builder-element mb-3">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.properties.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <input
        {...{
          onBlur: onBlurHandler,
          onChange: (e) => {
            if (isInputFieldTouched) {
              isInputFieldTouched();
            }
          },
          disabled:
            readOnly ||
            approve ||
            !element.editable ||
            (defValue && hasChiledReadOnly) ||
            ocrDisabled,
          className: `form-control form-view ${
            foundError ? "border border-danger" : ""
          }`,
          type: "date",
          defaultValue:
            defValue && isChild ? defValue : element.properties.value,
          label: element.properties.label,
          data: JSON.stringify(element),
          placeholder: element.properties.placeholder,
          ...(!element.past ? null : { min: formatDate(new Date()) }),
          ...(!element.future ? null : { max: formatDate(new Date()) }),
        }}
      />
      {foundError && <p className="text-danger">{foundError?.value}</p>}
    </div>
  );
}

export default DateField;
